const easeOutCubic = (x) => {
    return 1 - Math.pow(1 - x, 3);
};

const duration = 500;

function scrollToTarget(target, offset, origin) {
    origin = origin || window;
    offset = offset || 0;

    const top = target.getBoundingClientRect().top;
    const startPos = origin.pageYOffset;
    const diff = top + offset;

    let startTime = null;
    let requestId;

    const loop = (currentTime) => {
        if (!startTime) {
            startTime = currentTime;
        }

        const time = currentTime - startTime;

        const percent = Math.min(time / duration, 1);
        origin.scrollTo(0, startPos + diff * easeOutCubic(percent));

        if (time < duration) {
            // Continue moving
            requestId = origin.requestAnimationFrame(loop);
        } else {
            origin.cancelAnimationFrame(requestId);
        }
    };
    requestId = origin.requestAnimationFrame(loop);
};

new LiveEvent('click', '[data-scroll-link], .scroll-link', function scrollLink(e) {
    e.preventDefault();

    // const tabReviews = document.querySelector('[data-tab-open]');
    // const tabDescription = document.querySelector('[data-tab-close]');
    // const contentReviews = document.querySelector('[data-tab-content-open]');
    // const contentDescription = document.querySelector('[data-tab-content-close]');
    // tabReviews.classList.add('_active');
    // tabDescription.classList.remove('_active');
    // contentReviews.classList.add('_active');
    // contentDescription.classList.remove('_active');

    let target = null;
    if (this.dataset.selector) {
        target = document.querySelector(this.dataset.selector);
    } else {
        target = document.querySelector(this.getAttribute('href'));
    }
    const offset = parseInt(this.dataset.offset) || 0;
    if (target) {
        scrollToTarget(target, offset);
    }

});